import { Layout as CssModulesLayout, LayoutProps } from '@sunwebgroup/uds-ui/layout'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/layout' instead.
 */
export default Object.assign(
  styled(CssModulesLayout)<LayoutProps>``,
  { displayName: 'Layout' },
)
